module.exports = __webpack_public_path__ + "static/img/linkLink.b93f135.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameImg/linkLink.png
// module id = gMns
// module chunks = 1